import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import React, { useEffect } from 'react';

import { useAuth } from '~/shared/contexts/AuthContext';

const gb = new GrowthBook({
  apiHost: CONFIG.growthBookApiHost,
  clientKey: CONFIG.growthBookClientKey,
  enableDevMode: CONFIG.sentryEnvironment !== 'production',
  attributes: {
    environment: CONFIG.sentryEnvironment,
    app: 'dashboard',
  },
});

const GrowthBookContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { gymId } = useAuth();

  useEffect(() => {
    gb.init({ timeout: 2000 });
  }, []);

  useEffect(() => {
    if (gymId) {
      gb.setAttributes({
        ...gb.getAttributes(),
        gymId,
      });
    }
  }, [gymId]);

  return <GrowthBookProvider growthbook={gb}>{children}</GrowthBookProvider>;
};

export default GrowthBookContextProvider;
